// extracted by mini-css-extract-plugin
module.exports = {"modal":"CreateProjectModal_modal__2Kb9G"};